var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyUs3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0.5H4C1.794 0.5 0 2.51825 0 5V41C0 43.4818 1.794 45.5 4 45.5H32C34.206 45.5 36 43.4818 36 41V5C36 2.51825 34.206 0.5 32 0.5ZM4 41V5H32L32.002 41H4Z",
    fill: "#C10037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23H12V27.5H8V23ZM8 32H12V36.5H8V32ZM16 23H20V27.5H16V23ZM8 9.5H28V18.5H8V9.5ZM16 32H20V36.5H16V32ZM24 23H28V36.5H24V23Z",
    fill: "#C10037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUs3);
export default __webpack_public_path__ + "static/media/why-us-3.4d1acca06bd3e35a3d096a9111095e62.svg";
export { ForwardRef as ReactComponent };